import { client } from "./_base";

export const phtreatment = client("phtreatment", item => ({
  ...item,
}));
